module.exports = __webpack_public_path__ + "static/media/landingLogo.eb29a7f8.png";